import { render } from "./IntroScreen.vue?vue&type=template&id=05d18e82&scoped=true"
import script from "./IntroScreen.vue?vue&type=script&lang=js"
export * from "./IntroScreen.vue?vue&type=script&lang=js"

import "./IntroScreen.vue?vue&type=style&index=0&id=05d18e82&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05d18e82"]])

export default __exports__